module.exports = "/_next/static/images/69c978567b52e8890c41e0a21bce26ab-analysis.svg";